import { faEllipsisVertical, faEnvelope, faMessage, faPhone, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react'
import { Button, Dropdown, Modal } from 'react-bootstrap';
import { FaWhatsapp } from 'react-icons/fa';
import { CloneContact } from '../../../education/Contacts/ContactModule/CloneContactForm';
import DeleteModal from '../../../DeleteModal';
import { DeleteRequest, GetRequest, PutRequest } from '../../../../Utils/hooks/ApiHandler';
import { EditContactOffcanvas } from '../../../../pages/EditContactOffcanvas';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';
import useLocalStorageState from 'use-local-storage-state';
import { baseURL } from '../../../../Utils/constants/constant';
import Select from '@mui/material/Select';

export const ContactDetailsHeader = ({
    onlyDetail,
    nextPrevious,
    setNextPrevious,
    fetchWhatsappKey,
    fetchSmsKey,
    fetchSmtpDetails,
    apiLoading,
    integrationStatus,
    checkTwilio,
    isCheckingTwilio,
    setCallLogOpen,
    // setShowAddDealOffcanvas,
    contactGrant,
    onCanvasClose,
    contactId,
    showContactDetailsCanvas,
    setShowContactDetailsCanvas,
    fetchContactDetails,
    refetch,
    allContacts,
    styles,

}) => {
    const [customer, setCustomer] = useLocalStorageState("customer");
    const navigate = useNavigate();
    // Extract tokens from session
    const customerId = customer?.customer_details?.customer_id;
    const token = customer?.token?.authorization;
    const rf = customer?.token?.authentication;
    const headers = {
        authentication: rf,
        Authorization: token,
    };
    const extras = { customer, setCustomer, rf, navigate };

    const [activeCanvas, setActiveCanvas] = useState(null)

    //state for reassign modal
    const [showReassignModal, setShowReassignModal] = useState(false);
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);

    // clone contact canvas open state
    const [showCloneCanvas, setShowCloneCanvas] = useState(false);
    const [showEditContact, setShowEditContact] = useState(false);

    // for delete contact/user
    const [confirmDeleteId, setConfirmDeleteId] = useState(null);
    const [loading, setLoading] = useState(false)
    const [showUserDeleteModal, setShowUserDeleteModal] = useState(false);

    //  only for edit offcanvas
    const [showId, setShowId] = useState(false);
    const [temData, setTemData] = useState([]);
    const [contactDataCanvas, setContactData] = useState({});
    const [showOffcanvas, setShowOffcanvas] = useState(false);

    const customSelectStyles = {
        control: (base, state) => ({
            ...base,
            marginTop: '10px',
            minHeight: 38,
            fontSize: 13,
            padding: "0 4px",
            boxShadow: "none",
            border: state.isFocused ? "1px solid #2684FF" : "1px solid #d1d5db",
            "&:hover": {
                borderColor: "#60a5fa",
            },
        }),
        valueContainer: (base) => ({
            ...base,
            padding: "0 4px",
        }),
        input: (base) => ({
            ...base,
            padding: "2px 0",
            margin: 0,
        }),
        placeholder: (base) => ({
            ...base,
            fontSize: 13,
        }),
        singleValue: (base) => ({
            ...base,
            fontSize: 13,
        }),
        indicatorsContainer: (base) => ({
            ...base,
            height: 34,
            padding: "0 3px",
        }),
        dropdownIndicator: (base) => ({
            ...base,
            padding: "4px",
        }),
        option: (base) => ({
            ...base,
            fontSize: 13,
            padding: "6px 10px",
        }),
        menuList: (base) => ({
            ...base,
            maxHeight: 200,
            overflowY: "auto",
            scrollBehavior: "smooth",
            "::-webkit-scrollbar": {
                width: "8px",
            },
            "::-webkit-scrollbar-track": {
                background: "#f1f1f1",
                borderRadius: "4px",
            },
            "::-webkit-scrollbar-thumb": {
                background: "#c9c9c9",
                borderRadius: "4px",
            },
            "::-webkit-scrollbar-thumb:hover": {
                background: "#888",
            },
        }),
        menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
        multiValue: (base) => ({
            ...base,
            backgroundColor: "#3b82f6",
            color: "white",
            fontSize: 12,
        }),
        multiValueLabel: (base) => ({
            ...base,
            color: "white",
            fontWeight: 500,
        }),
        multiValueRemove: (base) => ({
            ...base,
            color: "white",
            ":hover": {
                backgroundColor: "#ef4444",
                color: "white",
            },
        }),
    };

    // setting temdata contactdata and other details for edit contact offcanvas
    useEffect(() => {
        if (!showId && !activeCanvas) return;
        (async () => {

            const res = await GetRequest(
                `contacts/getContactDetailsById/${showId}`,
                { headers },
                extras
            );
            if (res.err === false || res.status === "fail") {
                return;
            }
            const parsedVis = res?.data ? JSON.parse(res?.data[0]?.visible_to) : [];
            setTemData(parsedVis);
            setContactData(res.data[0]);
            activeCanvas === 'edit' ? setShowOffcanvas(true) : setShowCloneCanvas(true);
        })();
    }, [showId]);


    const nextContact = () => {
        if (nextPrevious < allContacts.length - 1) {
            setNextPrevious(nextPrevious + 1);
            // setAssociatedDeals(false)
        }
    };

    const previousContact = () => {
        if (nextPrevious > 0) {
            setNextPrevious(nextPrevious - 1);
            // setAssociatedDeals(false)
        }
    };

    // handle re assign user
    const handleReassignTask = async () => {
        setShowReassignModal(true);

        const res = await GetRequest(
            `users/users/fetchUserAsOwner/${customerId}`,
            { headers },
            { extras }
        );

        if (res?.status === "success") {
            // React Select format: { value, label }
            const options = res?.data?.map((user) => ({
                value: user.id,
                label: user.full_name,
            }));
            setUsers(options);
        }
    };

    // submit form for reassign.
    const handleSubmit = async () => {
        const payload = {
            customer_id: customerId,
            owner_id: selectedUser.value,
            contact_id: allContacts[nextPrevious].id,
        };
        const res = await PutRequest(
            `${baseURL}contacts/reassign/`,
            payload,
            { headers },
            extras
        );
        if (res.status === "success") {
            toast.success(res.message);
            setShowReassignModal(false);
            setShowContactDetailsCanvas(false);
        }
    };

    // reassign clear modal
    const handleCloseReassignModal = () => {
        setSelectedUser(null);
        setShowReassignModal(false);
    };

    // handle delete user
    // delete contact handler
    const handleDeleteUser = async (contact_id) => {
        setLoading(true)
        try {
            if (!contact_id) return;
            const res = await DeleteRequest(
                `contacts/deleteContact/${contact_id}`,
                { headers },
                { extras }
            );
            if (res.status === "success") {
                toast.success(res.message);
                await refetch();
                setLoading(false)
                setShowUserDeleteModal(false);
                setShowContactDetailsCanvas(false);
                return;
            } else if (res === "fail") {
                setLoading(false)
                setShowUserDeleteModal(false);
                toast.err(res.message);
            }
        } catch (error) {
            setLoading(false)
            toast.error("Internal Server Error");
        }
    };

    return (
        <>
            <div
                className="d-flex align-items-center justify-content-between fs-13"
                style={{ padding: "2px 0px 13px", color: "#0081d7" }}
            >
                {onlyDetail && <p></p>}
                {!onlyDetail &&

                    <div className="d-flex align-items-center gap-2">
                        <p
                            className="mb-0 btn-light btn d-flex align-items-center"
                            onClick={previousContact}
                            style={
                                nextPrevious === 0
                                    ? {
                                        pointerEvents: "none",
                                        color: "#969696",
                                        cursor: "no-drop",
                                        height: "30px",
                                        fontWeight: 300,
                                        borderRadius: 2,
                                        fontSize: 13,
                                        border: "1px solid lightblue",
                                    }
                                    : {
                                        cursor: "pointer",
                                        height: "30px",
                                        fontSize: "13px",
                                        borderRadius: 2,
                                        fontWeight: 300,
                                        border: "1px solid lightblue",
                                    }
                            }
                            disabled={nextPrevious === 0}
                        >
                            <i className="me-1 bi bi-chevron-left" /> Prev
                        </p>

                        <p
                            className="mb-0 btn-light btn d-flex justify-content-center align-items-center"
                            onClick={nextContact}
                            style={
                                nextPrevious === allContacts?.length - 1
                                    ? {
                                        pointerEvents: "none",
                                        cursor: "no-drop",
                                        height: "30px",
                                        fontWeight: 300,
                                        fontSize: "13px",
                                        borderRadius: 2,
                                        border: "1px solid lightblue",
                                    }
                                    : {
                                        cursor: "pointer",
                                        height: "30px",
                                        borderRadius: 2,
                                        fontWeight: 300,
                                        fontSize: "13px",
                                        border: "1px solid lightblue",
                                    }
                            }
                            disabled={nextPrevious === allContacts?.length - 1}
                        >
                            Next <i className="ms-1 bi bi-chevron-right" />
                        </p>
                        <p
                            className="mb-0 mx-2 "
                            style={{ borderRight: "1px solid #c9c9c9", height: 29 }}
                        ></p>
                        <p
                            className="mb-0"
                            style={{
                                height: "30px",
                                display: "flex",
                                alignItems: "center",
                                color: "black",
                                fontSize: "19px",
                                fontWeight: 300,
                            }}
                        >
                            {" "}
                            Contact Details{" "}
                        </p>
                    </div>
                }
                <div>
                    <div className="d-flex align-items-center gap-1">

                        <button
                            type="button"
                            className="btn btn-whatsapp p-2"
                            style={styles.listButtonsStyles}
                            onClick={fetchWhatsappKey}
                            disabled={apiLoading.whatsapp}
                        >
                            {" "}
                            {apiLoading.whatsapp ? (
                                <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                            ) : integrationStatus.whatsapp === "success" ? (
                                <>
                                    <FaWhatsapp style={{ fontSize: "13px" }} />
                                    Configure
                                </>
                            ) : (
                                <>
                                    <FaWhatsapp style={{ fontSize: "13px" }} /> WhatsApp
                                </>
                            )}{" "}
                        </button>

                        <button
                            type="button"
                            className="btn btn-default btnss"
                            onClick={fetchSmtpDetails}
                            disabled={apiLoading.email}
                            style={styles.listButtonsStyles}
                        >
                            {apiLoading.email ? (
                                <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                            ) : integrationStatus.email === "success" ? (
                                <>
                                    <FontAwesomeIcon
                                        icon={faEnvelope}
                                        style={styles.iconStyles}
                                    />
                                    Configure
                                </>
                            ) : (
                                <>
                                    <FontAwesomeIcon
                                        icon={faEnvelope}
                                        style={styles.iconStyles}
                                    />{" "}
                                    Email{" "}
                                </>
                            )}{" "}
                        </button>

                        <Dropdown
                            style={{ width: "55px" }}
                            className="dropdownsWithoutToggle"
                        >
                            <Dropdown.Toggle
                                variant="default"
                                style={styles.listButtonsStyless}
                                className="btn btn-default btnss"
                            >
                                <FontAwesomeIcon
                                    icon={faPhone}
                                    style={{
                                        fontSize: "15px",
                                        width: "20px",
                                        color: "#ffff",
                                    }}
                                />
                                Call
                            </Dropdown.Toggle>

                            <Dropdown.Menu
                                align="end"
                                style={{
                                    width: "8rem",
                                    boxShadow: "0 0 15px #d7d7d7",
                                    marginTop: "-22px",
                                    marginRight: "25px",
                                }}
                            >
                                <Dropdown.Item
                                    className="d-flex align-items-center btn"
                                    style={{
                                        fontSize: "12px",
                                        padding: "4px 21px",
                                    }}
                                    disabled={isCheckingTwilio}
                                    onClick={() => {
                                        checkTwilio();
                                    }}
                                >
                                    {isCheckingTwilio ? (
                                        <span
                                            className="spinner-border spinner-border-sm me-2"
                                            role="status"
                                        ></span>
                                    ) : (
                                        "Call Now"
                                    )}
                                </Dropdown.Item>
                                <Dropdown.Item
                                    className="d-flex align-items-center btn"
                                    style={{
                                        fontSize: "12px",
                                        padding: "4px 21px",
                                    }}
                                    onClick={() => {
                                        setCallLogOpen(true);
                                    }}
                                >
                                    Call log
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>{" "}

                        <button
                            type="button"
                            className="btn btn-default btnss"
                            style={styles.listButtonsStyles}
                            onClick={fetchSmsKey}
                        >
                            {" "}
                            {apiLoading.sms ? (
                                <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                            ) : integrationStatus.sms === "success" ? (
                                <>
                                    <FontAwesomeIcon
                                        icon={faMessage}
                                        style={styles.iconStyles}
                                    />{" "}
                                    SMS
                                </>
                            ) : (
                                <>
                                    <FontAwesomeIcon
                                        icon={faMessage}
                                        style={styles.iconStyles}
                                    />{" "}
                                    SMS
                                </>
                            )}
                        </button>

                        <Dropdown className="dropdownsWithoutToggle">
                            <Dropdown.Toggle
                                variant="default"
                                style={styles.listButtonsStyless}
                                className="btn btn-default btnss"
                            >
                                <FontAwesomeIcon icon={faEllipsisVertical} />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item onClick={handleReassignTask}>
                                    Reassign
                                </Dropdown.Item>
                                {showReassignModal && (
                                    <Modal
                                        show={showReassignModal}
                                        onHide={handleCloseReassignModal}
                                        backdrop="static"
                                        keyboard={false}
                                    >
                                        <Modal.Header closeButton>
                                            <Modal.Title>Reassign Task</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <p
                                                style={{
                                                    color: "#787878",
                                                    fontSize: 11,
                                                    fontWeight: 200,
                                                }}
                                            >
                                                This task has been reassigned to a new owner.
                                                They will manage all next steps and provide
                                                updates going forward.
                                            </p>
                                            <Select
                                                styles={customSelectStyles}
                                                options={users}
                                                value={selectedUser}
                                                onChange={setSelectedUser}
                                                placeholder="Select a user"
                                                isSearchable
                                                className="mb-4"
                                            />
                                        </Modal.Body>
                                        <div className="mb-3 d-flex justify-content-end gap-2 px-3">
                                            <Button
                                                variant="secondary"
                                                className="btn btn-default-outline btn-sm"
                                                onClick={handleCloseReassignModal}
                                            >
                                                Cancel
                                            </Button>
                                            <Button
                                                variant="default"
                                                onClick={handleSubmit}
                                                disabled={!selectedUser}
                                                className="btn btn-default btn-sm"
                                            >
                                                Submit
                                            </Button>
                                        </div>
                                    </Modal>
                                )}

                                {/* <Dropdown.Item>Share</Dropdown.Item> */}
                                {/* <Dropdown.Item
                                onClick={() => {
                                    if (!dealGrant.isCreate) {
                                        toast.warning("You are not authorized for this action!")
                                        return
                                    }
                                    setShowAddDealOffcanvas(true)
                                }}
                            >
                                Add Deal
                            </Dropdown.Item> */}
                                <Dropdown.Item onClick={() => {
                                    if (!contactGrant.isCreate) {
                                        toast.warning("You are not authorized for this action!")
                                        return
                                    }
                                    setShowId(contactId);
                                    setActiveCanvas("clone")
                                }}>
                                    Clone
                                </Dropdown.Item>
                                <Dropdown.Item
                                    onClick={(e) => {
                                        if (!contactGrant.isEdit) {
                                            toast.warning("You are not authorized for this action!")
                                            return
                                        }
                                        setShowId(contactId);
                                        setActiveCanvas('edit')
                                    }}
                                >
                                    Edit
                                </Dropdown.Item>
                                <Dropdown.Item
                                    onClick={() => {
                                        if (!contactGrant.isDelete) {
                                            toast.warning("You are not authorized for this action!")
                                            return
                                        }
                                        setShowUserDeleteModal(true)
                                    }}
                                >
                                    Delete
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        <p
                            className="mb-0 mx-2 "
                            style={{ borderRight: "1px solid #c9c9c9", height: 29 }}
                        ></p>
                        <button
                            type="button"
                            className="btn btn-default btnss"
                            style={styles.listButtonsStyles}
                            onClick={() => onCanvasClose()}
                        >
                            <FontAwesomeIcon icon={faXmark} className="ms-0" />
                        </button>
                    </div>
                </div>
            </div>
            {showUserDeleteModal && (
                <DeleteModal
                    onConfirm={() => {
                        handleDeleteUser(contactId);
                    }}
                    onClose={() => {
                        setConfirmDeleteId(null);
                        setShowUserDeleteModal(false);
                    }}
                    contactId={contactId}
                    isLoding={loading}
                    show={true}
                />
            )}
            {showCloneCanvas && (
                <CloneContact
                    refetch={refetch}
                    setActiveCanvas={setActiveCanvas}
                    showContactDetailsCanvas={showContactDetailsCanvas}
                    setShowContactDetailsCanvas={setShowContactDetailsCanvas}
                    setShowCloneCanvas={setShowCloneCanvas}
                    fetchContactDetails={fetchContactDetails}
                    contactId={contactId}
                    allContacts={allContacts}
                    show={true}
                    contact_data={contactDataCanvas}
                    setShow={() => {
                        setShowId(null);
                        setShowEditContact(false);
                    }}
                />
            )}
            {showId !== null && showOffcanvas && (
                <EditContactOffcanvas
                    allContacts={allContacts}
                    setActiveCanvas={setActiveCanvas}
                    show={true}
                    contact_data={contactDataCanvas}
                    temData={temData}
                    setShow={() => {
                        setShowId(null);
                        setShowOffcanvas(false);
                    }}
                    showContactDetailsCanvas={showContactDetailsCanvas}
                    setShowContactDetailsCanvas={setShowContactDetailsCanvas}
                    fetchContactDetails={fetchContactDetails}
                    contactId={contactId}
                />
            )}
        </>
    )
}